import { Slider } from '@mui/material';

interface TimelineProps {
  // eslint-disable-next-line no-unused-vars
  onChange: (newState: number) => void;
}
function Timeline({ onChange }: TimelineProps) {
  const marks = [
    {
      value: 48,
      label: 'Day -2',
    },
    {
      value: 24,
      label: 'Day -1',
    },
    {
      value: 15,
      label: '15 min',
    },
    {
      value: 5,
      label: '5 min',
    },
    {
      value: 0,
      label: 'Now',
    },
  ];

  const onChangeCommitted = (event: any, value: number | number[]) => {
    onChange(value as number);
  };

  return (
    <div style={{
      width: '50rem', position: 'relative', left: '50%', transform: 'translateX(-50%)',
    }}
    >
      <Slider
        aria-label="Timeline"
        defaultValue={0}
        max={48}
        step={null}
        marks={marks}
        color="secondary"
        onChangeCommitted={onChangeCommitted}
      />
    </div>
  );
}

export default Timeline;
